import { render, staticRenderFns } from "./camera.vue?vue&type=template&id=7985c9ba&scoped=true&"
import script from "./camera.vue?vue&type=script&lang=js&"
export * from "./camera.vue?vue&type=script&lang=js&"
import style0 from "./camera.vue?vue&type=style&index=0&id=7985c9ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7985c9ba",
  null
  
)

export default component.exports